;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { TOUR_OVERLAY_GROUPS } from "@/features/onboarding-tours/orchestrator/tour-overlay-groups";
import { tourStep } from "@/features/onboarding-tours/orchestrator/tour-step-builder";
import {
	TOUR_TARGETS,
	tourSelector,
} from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import type { TourStep } from "@/features/onboarding-tours/types/tour-definition";

const createDataProviderDialogTarget = tourSelector(
	TOUR_TARGETS.createDataProviderDialog,
);

export function buildCreateDataProviderDialogSteps({
	content,
	title,
}: {
	content: string;
	title: string;
}): TourStep[] {
	return [
		tourStep({
			content,
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.createDataProvider,
			},
			effect: "openCreateDataProvider",
			placement: "left",
			scrollBefore: createDataProviderDialogTarget,
			spotlightPadding: 8,
			target: createDataProviderDialogTarget,
			title,
			waitForTarget: true,
		}),
	];
}
